module.exports = __webpack_public_path__ + "static/media/gw.6c6e90fa.svg";